import RafThrottle from '@utilities/raf-throttle';

const BUTTON_HIDDEN_CLASS = 'button--is-hidden';
const READMORE_ACTIVE_CLASS = 'readmore--is-active';
const READMORE_OPEN_CLASS = 'readmore--is-opened';

const READMORE_BUTTON_HOOK = '[js-hook-rich-text-read-more]';
const READMORE_CONTENT_HOOK = '[js-hook-rich-text-readmore-content]';

const READMORE_HEIGHT = 400 + 100; //use offset on top of css to prevent readmore for 10px

class richTextBlock {
    constructor(element) {
        this.element = element;
        this.readMoreButton = this.element.querySelector(READMORE_BUTTON_HOOK);
        this.readMoreBlock = this.element.querySelector(READMORE_CONTENT_HOOK);

        this.bindEvents();

        this.init();

        RafThrottle.set([
            {
                element: window,
                event: 'resize',
                namespace: 'SetReadMoreClasses',
                fn: () => this.init(),
            },
        ]);
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.readMoreButton.addEventListener('click', e => {
            this.expand(e);
        });
    }

    init() {
        if (this.readMoreBlock.offsetHeight > READMORE_HEIGHT) {
            //Set readmore class if needed
            this.readMoreBlock.classList.add(READMORE_ACTIVE_CLASS);
        } else {
            //Remove if not needed (for resizing)
            this.readMoreBlock.classList.remove(READMORE_ACTIVE_CLASS);
        }
    }

    expand(e) {
        e.currentTarget.previousElementSibling.classList.add(READMORE_OPEN_CLASS);

        e.currentTarget.classList.add(BUTTON_HIDDEN_CLASS);
    }
}

export default richTextBlock;
